import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { Link,useLocation } from "react-router-dom";
import Layout from "../layouts/Layout";
import successLogo from '../assests/images/Icon/GreenBGtick.svg';

const PaymentSuccess = () => {
  const search = useLocation().search;
  const queryParam = new URLSearchParams(search);
  const [loading, setLoading] = useState(false);
// console.log(queryParam.get('tran_id'));
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  useEffect(() => {
    document.title = "Ultimate Organic Life - Payment Success";
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="checkout-page">
      {loading && (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      )}
      <div className="checkout-content-wrap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row justify-content-center">
                <div className="col-lg-7 col-md-6 col-12 ">
                  <div className="checkout-logo">
                    <div className="container">
                      <Link to="/" title="Ultimate">
                        <img src={"/assets/images/logo/Original_logo.png"} className="img-fluid" width="150" alt="Ultimate Organic Ecommerce Logo"/>
                      </Link>
                    </div>
                  </div>
                  <hr/>
                    <div className="thank-you">
                      <center>
                        <img src={successLogo} height={64} width={64} alt="successlogo" className="img-fluid pe-1" style={{position: 'relative', top:'10px'}} />
                      <div className="d-inline-block">
                        <h4 className="thank-you-sentence">
                          Your order is successfully placed
                        </h4>
                        <p>Thank you for purchasing our products!</p>
                      </div>
                      </center>
                    </div>
                    <br/>
                    <br/>
                    <div className="order-customer-info pb-4">
                      <h6> Order & Transaction information</h6>
                      <p>
                        <span className="d-inline-block p-2">Transaction ID: &nbsp;</span>
                        <span className="order-customer-info-meta">{queryParam.get('tran_id')}</span>
                      </p>
                      <p>
                        <span className="d-inline-block p-2">Amount Paid:</span>
                        <span className="order-customer-info-meta">{queryParam.get('amount')}</span>
                      </p>
                      <p>
                        <span className="d-inline-block p-2">Order ID:</span>
                        <span className="order-customer-info-meta">{queryParam.get('order_id')}</span>
                      </p>
                      {/* <p> */}
                      {/* </p> */}
                      <p>
                        <span className="d-inline-block p-2">Payment method:</span>
                        <span className="order-customer-info-meta">SslCommerz</span>
                      </p>
                      <p>
                        <span className="d-inline-block p-2">Payment status:</span>
                        <span className="order-customer-info-meta" style={{textTransform: 'uppercase'}}><span className="label-success status-label">Completed</span></span>
                      </p>
                    </div>
                    <Link to="/" className="btn payment-checkout-btn"> <i class="fa fa-arrow-left" aria-hidden="true"></i> {'<- Continue shopping'} </Link>
                </div>

                {/* <div className="col-lg-5 col-md-6 right">
                  <div className="pt-3 mb-4">
                    <div className="align-items-center">
                      <h6 className="d-inline-block p-4">Order number: #10000051</h6>
                    </div>
                    <div className="checkout-success-products p-3">
                      <div className="row show-cart-row d-md-none p-2">
                        <div className="col-9">
                          <a className="show-cart-link" href="#" data-bs-toggle="collapse" data-bs-target="#cart-item-51" aria-expanded="true">
                            Order information #10000051 <i className="fa fa-angle-down" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div className="col-3">
                          <p className="text-end mobile-total"> $58.08 </p>
                        </div>
                      </div>
                      <div id="cart-item-51" className="collapse-products collapse show  p-2" style={{}}>
                        <div className="row cart-item">
                          <div className="col-lg-3 col-md-3">
                            <div className="checkout-product-img-wrapper">
                              <img className="img-thumbnail img-rounded" src={''} width={64} height={64} alt="Foster Farms Takeout Crispy Classic(HS-183-A0)"/>
                                <span className="checkout-quantity">1</span>
                            </div>
                          </div>
                          <div className="col-lg-5 col-md-5">
                            <p className="mb-0">Foster Farms Takeout Crispy Classic</p>
                            <p className="mb-0">
                              <small>(Weight: 3KG, Boxes: 3 Boxes)</small>
                            </p>
                          </div>
                          <div className="col-lg-4 col-md-4 col-4 text-end">
                            <p>$52.80</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-2">
                            <p>Subtotal:</p>
                          </div>
                          <div className="col-6 float-end">
                            <p className="price-text text-end"> $52.80 </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-2">
                            <p>Shipping fee:</p>
                          </div>
                          <div className="col-6 float-end">
                            <p className="price-text text-end"> Free delivery - $0.00 </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-2">
                            <p>Discount:</p>
                          </div>
                          <div className="col-6 float-end">
                            <p className="price-text text-end"> $0.00 </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-2">
                            <p>Tax:</p>
                          </div>
                          <div className="col-6 float-end">
                            <p className="price-text text-end"> $5.28 </p>
                          </div>
                        </div>
                        <hr/>
                          <div className="row">
                            <div className="col-6">
                              <p>Total:</p>
                            </div>
                            <div className="col-6 text-end">
                              <p className="total-text raw-total-text"> $58.08 </p>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
